import { BoxesApiRemoteService } from '../../Services/api/boxes/boxes-service'
import { ICreateBoxPayload } from '../../Services/api/boxes/boxes.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class CreateBoxesUseCase
implements IFormUsecase<ICreateBoxPayload, void> {
  constructor (private readonly BoxesApi: BoxesApiRemoteService) {}
    

  public async handle (
    data: ICreateBoxPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.BoxesApi.create(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
